import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { getInputChecks } from '../../api/controlTestRuns';

/**
 * Warns when the files given for a test look wrong: the population also uploaded as evidence, the IPE proof being
 * the population itself, or one document uploaded twice. Renders nothing when everything is fine or cannot be checked.
 */
export default function InputChecksBanner({ controlUuid, populationFileId, ipeProofFileId }) {
  const [findings, setFindings] = useState([]);

  useEffect(() => {
    if (!controlUuid || !populationFileId) { setFindings([]); return undefined; }
    let cancelled = false;
    getInputChecks(controlUuid, { populationFileId, ipeProofFileId })
      .then((f) => { if (!cancelled) setFindings(f); })
      .catch(() => { if (!cancelled) setFindings([]); });     // a failed check never blocks the wizard
    return () => { cancelled = true; };
  }, [controlUuid, populationFileId, ipeProofFileId]);

  if (!findings.length) return null;
  return (
    <div className="mt-3 space-y-2" data-testid="input-checks-banner">
      {findings.map((f) => {
        const error = f.severity === 'error';
        return (
          <div key={`${f.code}-${(f.upload_ids || []).join('-')}`}
            className={`flex gap-2 rounded-md border px-3 py-2 text-xs ${error ? 'border-red-200 bg-red-50 text-red-800' : 'border-amber-200 bg-amber-50 text-amber-800'}`}>
            <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
            <span>{f.message}</span>
          </div>
        );
      })}
    </div>
  );
}
